import React from 'react';
import {
  Component,
  PuzzleButton,
  Container,
  PuzzleInput,
  PuzzleToolbar
} from 'puzzle';
import { InputChangeEvent } from "@progress/kendo-react-inputs";
import MainGrid from "../MainGrid/MainGrid";
import PoliciesManager from "../util/Policies";
import { setDocumentTitle } from "../util/Util";

class Templates extends Component {
  searchBar: any = React.createRef();
  searchTimer: any;
  /**
   * @inheritDoc
   */
  moduleDidMount = () => {
    setDocumentTitle(this.props.title);
    this.dispatch('reloadTemplates');
  };

  filterGridWithDelay = () => {
    clearTimeout(this.searchTimer);
    (this.searchTimer as any) = setTimeout(() => {
      this.dispatch('filterMainGrid', '', { mainGridFilter: { submissionNameInputText: this.state.searchText } })
    }, 300);
  };

  openCreateTemplate = () => {
    this.dispatch('createTemplate')
  };
  /**
   */
  onChangeSearchBar = (event: InputChangeEvent) => {
    const searchText = event.target.value;
    this.setState({ searchText }, this.filterGridWithDelay);
  };

  renderSearchBar = () => {
    return (
      <div className={'tp-searchbar-content'}>
        <div className={'tp-searchbar-combobox'}
             ref={this.searchBar}
             onFocus={() => this.searchBar.current.classList.add('k-state-focused')}
             onBlur={() => this.searchBar.current.classList.remove('k-state-focused')}>
          <PuzzleInput
            aria-label={this.translate('searchTemplates')}
            inputClassName={'tp-searchbar-input'}
            id={'templatesSearchBar'}
            name="templatesSearchBar"
            onChange={this.onChangeSearchBar}
            placeholder={this.translate('searchTemplates')}
            searchField
            value={this.state.searchText}
          />
        </div>
        <PuzzleToolbar className={'tp-page-header-action-toolbar'}>
          {
            PoliciesManager.hasTemplateCreatePolicy &&
            <PuzzleButton
              iconClass='tp-icon tp-add'
              themeColor={'primary'}
              className={'p-new-sub-btn'}
              onClick={this.openCreateTemplate}
            >
              {this.translate('newTemplate')}
            </PuzzleButton>
          }
        </PuzzleToolbar>
      </div>

    )
  };

  render() {
    return (
      <Container
        vBox
        className={'tp-page tp-templatesView-page'}
      >
        <MainGrid
          gridSectionAriaLabel={this.translate('SRL-section-table')}
          topSectionAriaLabel={this.translate('SRL-section-actions')}
          requestActionName={'getMainGridData'}
          searchText={this.state.searchText}
          sortable={true}
          templatesOnly={true}
          contextMenuEnabled={false}
          emptyGridConfig={{
            text: this.translate('gridEmptyLabel'),
            img: 'subs-grid'
          }}
          searchBarConfig={{
            pageTitle: this.translate('page-title'),
            renderSearchBar: this.renderSearchBar
          }}
          title={this.translate('grid-title')}
        />
      </Container>
    );
  }
}

export default Templates;
